import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';
import { useBreadcrumbsContext } from 'app/context';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthContext } from 'modules/auth/context';
import { EAccountPermissions } from 'modules/auth/context/permify/permify.interfaces';
import { BankStatementPageContent } from './components';

const BankStatementPage = () => {
  const { setItems, resetBreadcrumbs } = useBreadcrumbsContext();
  const { userInfo } = useAuthContext();
  const navigate = useNavigate();

  useEffect(() => {
    if (
      !userInfo?.permissions?.includes(EAccountPermissions.DISBURSEMENT_ADMIN)
    ) {
      navigate('/');
    }
  }, []);

  useEffect(() => {
    setItems(
      [
        { to: '/disbursement/balance', label: 'Desembolsos' },
        { to: '/disbursement/balance', label: 'Extrato' },
      ],
      <CurrencyExchangeIcon />,
    );

    return () => resetBreadcrumbs();
  }, []);

  if (!userInfo?.permissions?.includes(EAccountPermissions.DISBURSEMENT_ADMIN))
    return null;

  return <BankStatementPageContent />;
};

export default BankStatementPage;
